import { useMutation, useQueryClient } from '@tanstack/react-query';

import { engagementResourcesService } from '../services';

import { engagementResourcesKeys } from './useEngagementResources';

export function useArchiveResource(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => engagementResourcesService.archive(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: engagementResourcesKeys.lists() });
      void qc.invalidateQueries({ queryKey: engagementResourcesKeys.detail(id) });
    },
  });
}
